export class MunicipioRequest
{
    descricao: string;
    idProposta: number;
    idCotacao: number;
    cnpjCli: string;
    dataIni: Date;
    datafim: Date;
    tipoConsulta: string;
    idUsuario: number;
}